import { LANGUAGES } from '../../services/i18n';

export const BASE_URL = 'https://bitexen.com';

export const LANGUAGE_LIST = [
  {
    translationId: 'footer_english',
    value: LANGUAGES.EN
  },
  {
    translationId: 'footer_turkish',
    value: LANGUAGES.TR
  }
];
